/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The device clock stepped; earlier events in the run get back-corrected.
 * 
 * Mirrors kodiak-proto's ClockShiftEvent. Successor to the retired time_sync
 * type: ingestion normalizes time_sync (still emitted by not-yet-updated
 * devices) into this shape with source="phone", and the migration that
 * introduced run_clock_shift converted all stored time_sync rows.
 * @export
 * @interface ClockShiftPayload
 */
export interface ClockShiftPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: ClockShiftPayloadTypeEnum;
    /**
     * 
     */
    deviceTimeBeforeSeconds: number;
    /**
     * 
     */
    deviceTimeAfterSeconds: number;
    /**
     * 
     */
    deltaSeconds: number;
    /**
     * 
     */
    source: string;
    /**
     * 
     */
    clientIp?: string | null;
}


/**
 * @export
 */
export const ClockShiftPayloadTypeEnum = {
    ClockShift: 'clock_shift',
} as const;
export type ClockShiftPayloadTypeEnum = typeof ClockShiftPayloadTypeEnum[keyof typeof ClockShiftPayloadTypeEnum];


/**
 * Check if a given object implements the ClockShiftPayload interface.
 */
export function instanceOfClockShiftPayload(value: object): value is ClockShiftPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'clock_shift') return false;
    
    if ((!('deviceTimeBeforeSeconds' in (value as Record<string, any>)) && !('device_time_before_seconds' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceTimeBeforeSeconds'] === undefined && (value as Record<string, any>)['device_time_before_seconds'] === undefined)) return false;
    if ((!('deviceTimeAfterSeconds' in (value as Record<string, any>)) && !('device_time_after_seconds' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceTimeAfterSeconds'] === undefined && (value as Record<string, any>)['device_time_after_seconds'] === undefined)) return false;
    if ((!('deltaSeconds' in (value as Record<string, any>)) && !('delta_seconds' in (value as Record<string, any>))) || ((value as Record<string, any>)['deltaSeconds'] === undefined && (value as Record<string, any>)['delta_seconds'] === undefined)) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function ClockShiftPayloadFromJSON(json: any): ClockShiftPayload {
    return ClockShiftPayloadFromJSONTyped(json, false);
}

export function ClockShiftPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClockShiftPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'deviceTimeBeforeSeconds': json['device_time_before_seconds'],
        'deviceTimeAfterSeconds': json['device_time_after_seconds'],
        'deltaSeconds': json['delta_seconds'],
        'source': json['source'],
        'clientIp': json['client_ip'] === undefined ? undefined : json['client_ip'] === null ? null : json['client_ip'],
    };
}

export function ClockShiftPayloadToJSON(json: any): ClockShiftPayload {
    return ClockShiftPayloadToJSONTyped(json, false);
}

export function ClockShiftPayloadToJSONTyped(value?: ClockShiftPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'device_time_before_seconds': value['deviceTimeBeforeSeconds'],
        'device_time_after_seconds': value['deviceTimeAfterSeconds'],
        'delta_seconds': value['deltaSeconds'],
        'source': value['source'],
        'client_ip': value['clientIp'],
    };
}

